import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-sanity/dist/experimental/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(pages)/dove-siamo/[slug]/_components/DoveSiamoClient.tsx");
